import { useEffect, useState } from 'react';

const useNARDeepLinks = ({ property }) => {
    const [tradeAreaDetailsUrl, setTradeAreaDetailsUrl] = useState();
    const [commercialMapsUrl, setCommercialMapsUrl] = useState();
    const [attributeSiteSelectionUrl, setAttributeSiteSelectionUrl] = useState();
    const [commercialPropertyReportUrl, setCommercialPropertyReportUrl] = useState();
    const [commercialTradeAreaReport, setCommercialTradeAreaReport] = useState();

    useEffect(() => {
        const streetNumber = property?.streetNumber;
        const streetName = property?.streetName;
        const city = property?.city;
        const state = property?.stateProvince;
        const country = property?.country;
        const zip = property?.zipCode;

        if (!property || country !== 'US' || !city || !state) {
            return;
        }

        const cityEncoded = encodeURI(city);
        const stateEncoded = encodeURI(state);

        setTradeAreaDetailsUrl(
            `https://www.narrpr.com/deep-link?propertymode=commercial&action=neighborhooddetails&query=${cityEncoded}%20,${stateEncoded}&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Property%20Details`
        );

        setCommercialMapsUrl(
            `https://www.narrpr.com/deep-link?propertymode=commercial&action=searches&query=${cityEncoded}%2C%20${stateEncoded}&resulttype=map&maptooltype=10&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Property%20Details`
        );

        setAttributeSiteSelectionUrl(
            `https://www.narrpr.com/deep-link?propertymode=commercial&action=analyses&analysistype=bestbusinesses&query=${cityEncoded}%20,${stateEncoded}&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Property%20Details`
        );

        setCommercialTradeAreaReport(
            `https://www.narrpr.com/deep-link?propertymode=commercial&action=reports&reporttype=9&query=${cityEncoded}%2C%20${stateEncoded}&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Property%20Details`
        );

        if (!streetNumber || !streetName) {
            return;
        }

        const streetEncoded = encodeURI(`${streetNumber} ${streetName}`);

        setCommercialPropertyReportUrl(
            `https://www.narrpr.com/deep-link?propertymode=commercial&action=reports&reporttype=8&query=${streetEncoded}%2C%20${cityEncoded}%2C%20${stateEncoded}%20${zip}&listingID=${property.recordId}&cbcode=usicsc-n&ssocode=usicsc-n&utm_source=ICSC-ICSC&utm_medium=deep-link-sso&utm_campaign=Property%20Details`
        );
    }, [property]);

    return {
        tradeAreaDetailsUrl,
        commercialMapsUrl,
        attributeSiteSelectionUrl,
        commercialPropertyReportUrl,
        commercialTradeAreaReport,
    };
};

export default useNARDeepLinks;
